import { render } from "./Offer.vue?vue&type=template&id=76804260&scoped=true"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"

import "./Offer.vue?vue&type=style&index=0&id=76804260&scoped=true&lang=css"
import "./Offer.vue?vue&type=style&index=1&id=76804260&lang=css"
script.render = render
script.__scopeId = "data-v-76804260"

export default script